module.exports = __webpack_public_path__ + "images/assets/e56ca8dec2190f68f3c9784cda9707b7.svg";